import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { SearchComponent } from '../../components/common/search/search.component';
import { Configuration } from '../../configuration';
import { SelectableItem } from '../../models/common/selectableItem';
import { ContractAwardSearchModel, ContractAwardSummaryDto } from '../../models/contract.awards/contract.award.models';
import { ContractAwardService } from '../../services/contract.award.service';
import { Helpers } from '../../helpers';
import { Router, ActivatedRoute } from '@angular/router';
import { NoticeStatus } from '../../models/notices/notice.enums';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';

@Component({
    selector: 'competitor-notice',
    template: require('./competitor.notice.component.html')
})
export class CompetitorNoticeComponent extends SearchComponent<ContractAwardSearchModel, ContractAwardSummaryDto> implements OnInit {

    options: Array<SelectableItem<string>>;
    resultOptions;
    
    supplierId: number;
    noticeStatus: NoticeStatus;
    routeParamsSub: Subscription;


    @ViewChild('resultsPage', { static: false }) private resultsView;

    constructor(private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly contractAwardService: ContractAwardService,
        helpers: Helpers, configuration: Configuration,
        loggedInUserService: LoggedInUserService) {
        super(new ContractAwardSearchModel(configuration), contractAwardService, helpers);

        var user = loggedInUserService.getCurrentUser();
        this.supplierId = user.supplierId;
        this.noticeStatus = NoticeStatus.Live;

        this.resultOptions = {
            availableButtons: ['print', 'bookmark']
        };

        this.options = [
            { text: 'Most Recent', value: 'PublishedDate' },
            { text: 'Start Date', value: 'StartDate' },
            { text: 'End Date', value: 'EndDate' },
            { text: 'Type', value: 'Type' },
            { text: 'Title', value: 'Title' }
        ];

        if (!this.request.sortProperty) {
            this.request.sortProperty = 'PublishedDate';
        }
    }

    ngOnInit() {

        $('#view-competitor-modal').modal('hide');
        $('#view-competitor-modal2').modal('hide');
        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            this.request.id = JSON.parse(params['id']) as number;
        });

        this.search();
    }

    search() {
        this.request.supplierId = this.supplierId;
        this.request.status = this.noticeStatus;

        return super.search();
    }

    searchCallback(results) {

        super.searchCallback(results);

        if ((this.results == null || this.results.totalRecords == 0) && this.noticeStatus == NoticeStatus.Live) {
            this.noticeStatus = NoticeStatus.Expired;
            this.search();
        }
        else {
            if (this.resultsView) {
                this.resultsView.onSearchComplete();
            }
        }     
    }

    resetParameters() {
        this.request.reset();

        this.results = null;
    }


}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/competitor.notice.component.ts